export default __webpack_public_path__ + "static/media/5_paycomet.71256a83.svg";